import { Routes, Route } from "react-router-dom";

import HomePage from "../pages/main/homepage"
import Ordinationen from "../pages/main/ordinationen"
import Termine from "../pages/main/termine";

import Team from "../pages/main/team";
import TeamRoutes from "./teamroutes";

import Leistungen from "../pages/main/leistungen";
import LeistungenRoutes from "./leistungsroutes";

import Kontakt from "../pages/main/kontakt";
import KontaktRoutes from "./kontaktroutes";

import Jobs from "../pages/main/jobs";

import Gesundheitsvorsorge from "../pages/main/gesundheitsvorsorge";
import Gesundheitroutes from "./gesundheitroutes";

import Curse from "../pages/main/curse";
import Reanimationstraining from "../pages/main/reanimation";

import Laufteam from "../pages/main/laufen";
import Hinweise from "../pages/main/hinweise";

import Links from "../pages/main/links";
import Slides from "../pages/main/slide";

import StoreRoutes from "./storeroutes";



const MainRoutes = () => {
    return (
        <Routes>
            <Route index element={<HomePage />} />
            <Route path="/ordinationen" element={<Ordinationen />}/>
            <Route path="/termine" element={<Termine />}/>
            <Route path="/team" element={<Team />}/>
            {TeamRoutes}

            <Route path="/leistungen" element={<Leistungen />}/>
            {LeistungenRoutes}  

            <Route path="/kontakt" element={<Kontakt />}/>
            {KontaktRoutes}

            <Route path="/jobs" element={<Jobs />}/>

            <Route path="kurse" element={<Curse />}/>
            <Route path="/kurse/reanimation" element={<Reanimationstraining />}/>

            <Route path="/lauf/:id" element={<Laufteam />} />

            <Route path="/hinweise" element={<Hinweise />} />
            <Route path="/galerie" element={<Slides />} />
            <Route path="/links" element={<Links />} />

            {StoreRoutes}
        </Routes>
    )
}

export default MainRoutes;